import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { ArrowDown, GroupLogo} from '../../assets';
import { useRecoilValue } from 'recoil';
import { userFirstName } from '../../recoil';
import { UserOptionsList } from '../UserOptionsList/UserOptionsList';
import styles from './DesktopHeader.module.css';
import { useLocation } from 'react-router-dom';
import { preSubmissionUrls } from '../../constants/CommonDetails';

const LeftSection = () => (
  <div
    className={styles.leftSection}
    role='button'
    tabIndex='0'
  >
    <img className={styles.logoImage} src={GroupLogo} alt='Vodacom logo' />
  </div>
);

const RightSection = () => {
  const location = useLocation();
  const [isUserOptionsOpen, setUserOptionsOpen] = useState(false);
  const name = useRecoilValue(userFirstName);
  const shouldShowLogout = preSubmissionUrls.includes(location.pathname);

  return (
    <div className={styles.rightSection}>
      {name &&
        <div className={styles.dropDownDiv}>
          <div className={styles.greeting}>
            Hi {name}
          </div>
          {shouldShowLogout && (
            <>
              <img
                className={`${styles.userOptionsImg} ${isUserOptionsOpen ? styles.rotate : ''}`}
                src={ArrowDown}
                alt='Dropdown Logo'
                onClick={() => setUserOptionsOpen(!isUserOptionsOpen)}
                onKeyDown={() => setUserOptionsOpen(!isUserOptionsOpen)}
                role='presentation'
              />
              {isUserOptionsOpen && (
                <div
                  className={styles.userOptionsBackground}
                  onClick={() => setUserOptionsOpen(false)}
                  onKeyDown={() => setUserOptionsOpen(false)}
                  role='presentation'
                >
                  <div className={styles.dropDown}>
                    <UserOptionsList
                      isUserOptionsOpen={isUserOptionsOpen}
                      setUserOptionsOpen={setUserOptionsOpen}
                    />
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      }
    </div>
  );
};

export const DesktopHeader = ({ children,isGroupLogo }) => (
  <div className={styles.headerContainer}>
    <LeftSection isGroupLogo={isGroupLogo}/>

    {children}

    <RightSection />
  </div>
);

DesktopHeader.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  isGroupLogo:PropTypes.bool
};
